import AccountConfigRepository from '../../model/AccountConfigRepository'
import EventRepository from '../../model/EventRepository'
import EventProductRepository from '../../model/EventProductRepository'
import {
  required
} from 'vuelidate/lib/validators'
import greaterOrEqualTo from '../../validators/greaterOrEqualTo'
import inParentBounds from '../../validators/inParentBounds'
import noOverlapInSimilarSiblings from '../../validators/noOverlapInSimilarSiblings'
import noMatchinOccurrences from '../../validators/noMatchinOccurrences'
import noDuplicateOccurrences from '../../validators/noDuplicateOccurrences'
import EventForm from '../EditEvent/EventForm.vue'
import EventItems from './CopyEventItems.vue'
import uuid from 'uuid'
import uniq from 'lodash/uniq'

export default {
  name: 'CopyEventView',

  data () {
    return {
      loading: false,
      step: 0,

      regions: [],
      types: [],
      customerGroups: [],
      eventCodeOccurrences: [],
      productOccurrences: [],
      maxCustomerGroupId: null,

      event: {
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        notes: null,
        discountedProducts: [],
        specialPromotions: []
      }
    }
  },

  computed: {
    currentProductOccurrences () {
      let discountOccurrences = this.event.discountedProducts.reduce((result, discount) => {
        return result.concat(this.getCurrentDiscountOccurrences(discount))
      }, [])
      let promotionOccurrences = this.event.specialPromotions.reduce((result, promotion) => {
        return result.concat(this.getCurrentPromotionOccurrences(promotion))
      }, [])

      return discountOccurrences.concat(promotionOccurrences)
    },

    allProductOccurrences () {
      return this.productOccurrences.concat(this.currentProductOccurrences)
    }
  },

  validations () {
    return {
      event: {
        name: {
          required
        },
        eventCode: {
          required,
          unique: noMatchinOccurrences('eventCodeOccurrences', (value, parentVm) => {
            return {
              regionId: parentVm.regionId,
              eventCode: value.toLowerCase(),
              type: parentVm.type
            }
          })
        },
        startDate: {
          required
        },
        endDate: {
          required,
          greater: greaterOrEqualTo('startDate')
        },
        regionId: {
          required
        },
        type: {
          required
        },


        discountedProducts: {
          $each: {
            unique: noDuplicateOccurrences(
              this.getCurrentDiscountOccurrences,
              this.getMatchingDiscountOccurrences,
              this.getDisplayableDiscountOccurrences
            ),
            startDate: {
              required,
              inBounds: inParentBounds('event.startDate', 'event.endDate'),
              noOverlap: noOverlapInSimilarSiblings(
                'event.discountedProducts',
                'startDate',
                'endDate',
                (discount1, discount2) => {
                  return discount1.id === discount2.id &&
                    discount1.customerGroupId === discount2.customerGroupId
                }
              )

            },
            endDate: {
              required,
              inBounds: inParentBounds('event.startDate', 'event.endDate'),
              greater: greaterOrEqualTo('startDate'),
              noOverlap: noOverlapInSimilarSiblings(
                'event.discountedProducts',
                'startDate',
                'endDate',
                (discount1, discount2) => {
                  return discount1.id === discount2.id &&
                    discount1.customerGroupId === discount2.customerGroupId
                }
              )

            },
            page: {
              required
            },
            positionOnPage: {
              required
            },
            salesPrice: {
              required
            }
          }
        },


        specialPromotions: {
          $each: {
            unique: noDuplicateOccurrences(
              this.getCurrentPromotionOccurrences,
              this.getMatchingPromotionOccurrences,
              this.getDisplayablePromotionOccurrences
              //TODO: also c heck copy to region.
            ),
            name: {
              required
            },
            startDate: {
              required,
              inBounds: inParentBounds('event.startDate', 'event.endDate')
            },
            endDate: {
              required,
              inBounds: inParentBounds('event.startDate', 'event.endDate'),
              greater: greaterOrEqualTo('startDate')
            },
            page: {
              required
            },
            positionOnPage: {
              required
            }
          }
        }
      }
    }
  },

  components: {
    'event-items': EventItems,
    'event-form': EventForm
  },

  methods: {
    cancel () {
      this.$router.push('/')
    },

    getCurrentDiscountOccurrences (discount) {
      return [{
        customerGroupId: discount.customerGroupId,
        startDate: discount.startDate,
        endDate: discount.endDate,
        regionId: this.event.regionId,//discount.regionId,
        id: discount.id,
        eventCode: this.event.eventCode
      }]
    },

    getCurrentPromotionOccurrences (promotion) {

/*      console.log('this.event.regionId:', this.event.regionId)
      console.log('promotion.regionId:', promotion.regionId)
      console.log('getCurrentPromotionOccurrences: ', promotion)*/
      if (promotion.rewards.awardedProducts.length) {
        return promotion.rewards.awardedProducts.map(product => {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            regionId: this.event.regionId,//promotion.regionId,
            id: product.productId || product.productID,
            eventCode: this.event.eventCode
          }
        })
      } else {
        return promotion.requirements.purchasedProducts.map(product => {
          return {
            customerGroupId: promotion.customerGroupId,
            startDate: promotion.startDate,
            endDate: promotion.endDate,
            regionId: this.event.regionId,//promotion.regionId,
            id: product.productId || product.productID,
            eventCode: this.event.eventCode
          }
        })
      }
    },

    getDisplayableDiscountOccurrences (discount) {
      let occurrences = this.getMatchingDiscountOccurrences(discount)
      return uniq(occurrences.map(occurrence => {
        return occurrence.eventCode
      })).join(', ')
    },

    getMatchingDiscountOccurrences (discount) {
    //  console.log('parentVm.regionId:', parentVm.regionId)
      console.log('getMatchingPromotionOccurrences in: ', discount)
      let occurrencesToCheck = this.getCurrentDiscountOccurrences(discount)
      let allOccurrences = this.allProductOccurrences

      let matchCheckFunction = (occurrenceA, occurrenceB) => {

        if (occurrenceA.customerGroupId === occurrenceB.customerGroupId &&
          occurrenceA.id === occurrenceB.id) {


          if (occurrenceA.regionId !== occurrenceB.regionId) {
            return true
          } else
            return occurrenceA.startDate <= occurrenceB.endDate &&
              occurrenceA.endDate >= occurrenceB.startDate
        } else {
          return false
        }


      }

      let ret = occurrencesToCheck.reduce((result, occurenceToCheck) => {
        return result.concat(allOccurrences.filter(occurence => {
          return matchCheckFunction(occurence, {...occurenceToCheck, regionId: discount.regionId})
        }))
      }, [])
      // console.log('getMatchingPromotionOccurrences ret: ', ret)
      // if (ret.length ) {
      //   console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!1")
      // }
      return ret
    },


    getDisplayablePromotionOccurrences (promotion) {

      //console.log('getDisplayablePromotionOccurrences: ', promotion)

      let occurrences = this.getMatchingPromotionOccurrences(promotion)
      return uniq(occurrences.map(occurrence => {
        return occurrence.eventCode
      })).join(', ')
    },

    getMatchingPromotionOccurrences (promotion) {

      //console.log('getMatchingPromotionOccurrences in: ', promotion)
      let occurrencesToCheck = this.getCurrentPromotionOccurrences(promotion)
      let allOccurrences = this.allProductOccurrences

/*      let matchCheckFunction = (occurrenceA, occurrenceB) => {
        //TODO: restore me
        if (occurrenceA.regionId !== occurrenceB.regionId) {
          return true
        } else
        return occurrenceA.customerGroupId === occurrenceB.customerGroupId &&
          occurrenceA.id === occurrenceB.id &&
          occurrenceA.startDate <= occurrenceB.endDate &&
          occurrenceA.endDate >= occurrenceB.startDate

      }*/

      let matchCheckFunction = (occurrenceA, occurrenceB) => {
        if (occurrenceA.customerGroupId === occurrenceB.customerGroupId &&
          occurrenceA.id === occurrenceB.id) {


          if (occurrenceA.regionId !== occurrenceB.regionId) {
            return true
          } else
            return occurrenceA.startDate <= occurrenceB.endDate &&
              occurrenceA.endDate >= occurrenceB.startDate
        } else {
          return false
        }
      }

      let ret = occurrencesToCheck.reduce((result, occurenceToCheck) => {
        return result.concat(allOccurrences.filter(occurence => {
          return matchCheckFunction(occurence, {...occurenceToCheck, regionId: promotion.regionId})
        }))
      }, [])
      // console.log('getMatchingPromotionOccurrences ret: ', ret)
      // if (ret.length ) {
      //   console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!2")
      // }
      return ret
    },

    loadStep0 () {
      //console.log('copyEvent.loadStep0')
      this.loading = true
      let promises = []
      let eventId = this.$route.params.id

      return this.accountConfigRepository.getCustomerGroupIds()
        .then(groupIds => {
          this.customerGroups = this.eventRepository.getCustomerGroups(groupIds)
          this.eventRepository.setMaxCustomerGroupId(groupIds.maxGroupId)
        })
        .then(() => {
          this.statuses = this.eventRepository.getStatuses()
          this.types = this.eventRepository.getTypes()


          promises.push(
            this.eventRepository.getEvent(eventId)
            .then(event => {
              event.discountedProducts = []
              event.specialPromotions = []
              this.event = event
            })
          )

          promises.push(
            this.eventRepository.getStoreRegions()
            .then(regions => {
              this.regions = regions
            })
          )

          return Promise.all(promises)
            .then(() => {
              this.loading = false
            })
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    loadStep1 () {
      //console.log('copyEvent.loadStep1')
      this.loading = true
      let eventId = this.$route.params.id

      return this.eventRepository.getEvent(eventId)
        .then(event => {
         // console.log('event: ', event)
          this.event.discountedProducts = event.discountedProducts.map(discount => {
            let isCustomDate = discount.startDate !== event.startDate || discount.endDate !== event.endDate
            return Object.assign(discount, {
              isCustomDate: isCustomDate,
              uuid: uuid.v4(),
              regionId: event.regionId,
              startDate: this.event.startDate,
              endDate: this.event.endDate
            })
          })

          this.event.specialPromotions = event.specialPromotions.map(promotion => {
           // console.log("promotion: ", promotion);
            let isCustomDate = promotion.startDate !== event.startDate || promotion.endDate !== event.endDate
            return Object.assign(promotion, {
              isCustomDate: isCustomDate,
              uuid: uuid.v4(),
              regionId: event.regionId,
              startDate: this.event.startDate,
              endDate: this.event.endDate
            })
          })
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    nextStep () {
      console.log('copyEvent.nextStep')
      this.loading = true

      if (this.$v.$invalid) {
        this.$v.$touch()
        this.loading = false
        return
      }

      this.eventRepository.getEventCodeOccurrences()
        .then(eventCodeOccurrences => {
          this.eventCodeOccurrences = eventCodeOccurrences
        })
        .then(() => {
          if (this.$v.$invalid) {
            this.$v.$touch()
            this.loading = false
            return
          }

          return this.loadStep1()
            .then(() => {
              this.$v.$reset()
              this.loading = false
              this.step = 1
            })
            .catch(error => {
              this.loading = false
              this.$reportError(error)
            })
        })
    },

   save () {
      console.log('copyEvent.save')
      this.loading = true

      if (this.$v.$invalid) {
        this.$v.$touch()
        this.loading = false
        return
      }

      console.log(this.eventProductRepository)

      this.eventProductRepository.getProductOccurrences(this.event.regionId, this.event.startDate, this.event.endDate)
        .then(productOccurrences => {
          console.log('copyEvent.save - products', productOccurrences)
          this.productOccurrences = productOccurrences
        })
        .then(async () =>  {
          if (this.$v.$invalid) {
            this.$v.$touch()
            this.loading = false
            return
          }

          console.log('pre copyEvent', this.event)
          return await this.eventRepository.copyEvent(this.event)
            .then(event => {
              this.$router.push('/edit-event/' + event.id)
            })
            .catch(error => {
              this.loading = false
              this.$reportError(error)
            })
        })
    }
  },

  created () {
    this.accountConfigRepository = new AccountConfigRepository(this.$api)
    this.eventRepository = new EventRepository(this.$api)
    this.eventProductRepository = new EventProductRepository(this.$api)
    this.loadStep0()
  }
}



// WEBPACK FOOTER //
// ./src/views/CopyEvent/CopyEvent.js